'use es6';

import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { useTracker } from '../../utils/hooks/useTracker';
import { DASHBOARD_ACTION_SET_DEFAULT } from '../../dialog/dialogTypes';
import { getId, getName } from '../../data/schemas/dashboardSchema';
import { useShowDialog, useHideDialog } from '../../dialog/ducks';
import { EVENTS } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const SetDefaultDashboardButton = ({
  dashboard,
  defaultDashboardId,
  onDefaultChange,
  appUsageTracker
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const showDialog = useShowDialog();
  const hide = useHideDialog();
  const isAlreadyDefault = getId(dashboard) === defaultDashboardId;
  const actionKey = isAlreadyDefault ? 'remove-default' : 'set-default';
  const tooltipKey = isAlreadyDefault ? 'alreadyDefault' : null;
  const onConfirm = () => {
    onDefaultChange(isAlreadyDefault);
    hide();
    ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `reporting-action-components.dashboards.editDefaultDashboard.${actionKey}.success`,
        options: {
          dashboardName: getName(dashboard)
        }
      }),
      type: 'success'
    });
  };
  const onClick = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.clickSetDefaultDashboard, {
        actionType: 'edit',
        action: 'edit-default-dashboard',
        assetType: 'dashboard',
        interactionSource: 'dialog'
      });
    }
    showDialog({
      dialogType: DASHBOARD_ACTION_SET_DEFAULT,
      dialogProps: {
        isAlreadyDefault,
        editTypeKey: actionKey,
        onConfirm,
        appUsageTracker
      }
    });
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reporting-action-components.dashboards.editDefaultDashboard.tooltip.${tooltipKey}`
    }),
    placement: "left",
    disabled: !tooltipKey,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "dashboard-action-set-default-dashboard",
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `reporting-action-components.dashboards.editDefaultDashboard.${actionKey}.name`
      })
    })
  }, actionKey);
};
SetDefaultDashboardButton.propTypes = {
  dashboard: PropTypes.instanceOf(ImmutableMap).isRequired,
  defaultDashboardId: PropTypes.number,
  onDefaultChange: PropTypes.func.isRequired,
  appUsageTracker: PropTypes.object.isRequired
};
export default SetDefaultDashboardButton;